<script setup>
import {computed, defineProps} from "vue";
import VueMultiselect from "vue-multiselect";

const props = defineProps(['value', 'trackersList', 'multiple']);
const emit = defineEmits('input');

const trackers = computed({
    get: () => props.value,
    set: (value) => {
        emit('input', value);
    }
});
</script>

<template>
    <VueMultiselect
        v-model="trackers"
        :multiple="multiple"
        :options="trackersList"
        select-label=""
        deselect-label=""
        placeholder="Type to search your trackers"
        label="name"
        track-by="name"
        class="multiselect-mid selectbox selectbox-mid"
    >
        <template slot="option" slot-scope="props">
            <span v-b-popover.hover.top="props.option.created_by + ': ' + props.option.created_at">{{props.option.name}}</span>
        </template>
    </VueMultiselect>
</template>

<style scoped>

</style>
